import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import type {
  Error,
  TestWebhookProfile,
  TestWebhookResponse
} from '@eggplant/types'

interface Props {
  params: TestWebhookProfile
  onSuccess: (result: TestWebhookResponse) => void
  onError: (error: Error) => void
}

const TestWebhookConnectionRequest = ({
  params,
  onSuccess,
  onError
}: Props) => {
  const url = `${NOTIFICATION_SERVICE}/webhooks/test`

  return (
    <AuthenticatedDataRequest
      method='post'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default TestWebhookConnectionRequest
